import React from 'react';
import PropTypes from 'prop-types';

import useAppContext from '../../../context/useAppContext';
import { useTranslation } from 'react-i18next';

import { Button } from '@weezevent/nacre';
import { QueueCTATooltip } from '../widgetSteps/queueStepConfig';

import Style from './queue-settings-cta.module.css';

export function QueueCTAButton({ disabled, organization, eventId, widgetKey }) {
    const { t } = useTranslation();

    return (
        <QueueCTATooltip disabled={disabled}>
            <Button
                disabled={disabled}
                onClick={() => {
                    window.open(`${window.location.origin}/ticket/O${organization.id}/E${eventId}/settings/queue/${widgetKey}`);
                }}
            >
                {t('ticket.widget.form.configure_waiting_line_cta')}
            </Button>
        </QueueCTATooltip>
    );
}
export default function QueueSettingsCTA({ disabled, eventId, widgetKey, children }) {
    const [{ organization }] = useAppContext();
    const { t } = useTranslation();

    return (
        <div>
            <h4>{t('ticket.widget.form.configure_waiting_line')}</h4>
            <p>{t('ticket.widget.form.configure_waiting_line_description')}</p>
            <Button.Group className={Style['button-group']}>
                {children}
                <QueueCTAButton disabled={disabled} organization={organization} eventId={eventId} widgetKey={widgetKey} />
            </Button.Group>
        </div>
    );
}

QueueSettingsCTA.propTypes = {
    disabled: PropTypes.bool,
    eventId: PropTypes.oneOf([PropTypes.number, PropTypes.string]), // just like TS <any>
    widgetKey: PropTypes.string,
    children: PropTypes.node
};
